// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanaryToolbarDocumentTsx from "./CanaryToolbarDocument.tsx";

let make = CanaryToolbarDocumentTsx.ToolbarDocument;

export {
  make,
}
/* make Not a pure module */
